import { formatDisplayDate, formatDisplayDateTime, formatYen } from "@carry/shared";

export const formatDate = formatDisplayDate;

/** ISO 日付 (YYYY-MM-DD) を days 日ずらす。ローカルタイムゾーンで計算 (UTC 変換による日付ズレを避ける)。 */
export function shiftDate(iso: string, days: number): string {
  const d = new Date(`${iso}T00:00:00`);
  d.setDate(d.getDate() + days);
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
}

/** iso の年月を months ヶ月ずらした日付を `YYYY-MM-DD` で返す (月末は丸める). */
export function shiftMonth(iso: string, months: number): string {
  const d = new Date(`${iso}T00:00:00`);
  const targetDay = d.getDate();
  d.setDate(1);
  d.setMonth(d.getMonth() + months);
  const lastDay = new Date(d.getFullYear(), d.getMonth() + 1, 0).getDate();
  d.setDate(Math.min(targetDay, lastDay));
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
}

export const formatDateTime = formatDisplayDateTime;

/** ローカルタイムの本日を `YYYY-MM-DD` で返す. */
export function localToday(): string {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
}

/** 実行環境のタイムゾーンに依存せず JST (UTC+9) の本日を `YYYY-MM-DD` で返す. */
export function jstToday(): string {
  const now = new Date();
  const jst = new Date(now.getTime() + 9 * 60 * 60 * 1000);
  return jst.toISOString().slice(0, 10);
}

/**
 * 注文明細の金額の表示 (Issue #736 / #775)。null (算出不能) は単価が未入力であることを意味する `—`。
 * 算出そのものは `@carry/shared` の `lineSubtotal` / `itemsTotal` に集約している
 * (driver の配達先詳細と同じ規約で算出するため)。ここにあるのは `—` と出す admin 固有の判断だけ
 * (driver は同じ状態を `未設定` / `未算出` と呼ぶ)。通貨表記は全画面共通の `formatYen` に委ねる。
 */
export function formatAmount(amount: number | null): string {
  return amount === null ? "—" : formatYen(amount);
}
